import { render, staticRenderFns } from "./compare-view.vue?vue&type=template&id=1b119012&scoped=true&"
import script from "./compare-view.vue?vue&type=script&lang=js&"
export * from "./compare-view.vue?vue&type=script&lang=js&"
import style0 from "./compare-view.vue?vue&type=style&index=0&id=1b119012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b119012",
  null
  
)

export default component.exports